
import { oz } from '@weft/utils';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { PromotionModelSchema } from './promotion-model-schema';

export const NewPromotionSchema = oz.object({
  name: oz.string().nonempty('Name is required'),
  description: withNullAsOptional(oz.string().nonempty()),
  promotionModel: PromotionModelSchema,
}).openapi('NewPromotion');

export type NewPromotion = oz.infer<typeof NewPromotionSchema>;